import * as types from './types';

const getScore = (branchId, siteId) => ({
  type: types.FETCH_SCORE,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/getInfoReputation?siteId=${siteId}`,
    method: 'GET',
    query: { branchId }
  }
});

export { getScore };
